// Generated file - do not change manually!

/**
 * Different types of AvatarSize.
 */
export enum AvatarSize {
  /**
   * component size - 5rem font size - 2.5rem
   */
  L = 'L',

  /**
   * component size - 4rem font size - 2rem
   */
  M = 'M',

  /**
   * component size - 3rem font size - 1.5rem
   */
  S = 'S',

  /**
   * component size - 7rem font size - 3rem
   */
  XL = 'XL',

  /**
   * component size - 2rem font size - 1rem
   */
  XS = 'XS'
}
